import React from 'react';
import { CheckCircle2Icon, LockIcon, PrinterIcon, SmartphoneIcon, ZapIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { CTAButton } from './ui/CTAButton';
import { IMAGENES, MONEDA, PRECIO, PRECIO_ANTERIOR, checklistOferta } from '../data/landing';
const confianza = [{
  icono: LockIcon,
  texto: 'Pago seguro'
}, {
  icono: ZapIcon,
  texto: 'Acceso inmediato'
}, {
  icono: SmartphoneIcon,
  texto: 'Celular, tablet o PC'
}, {
  icono: PrinterIcon,
  texto: 'Listo para imprimir'
}];
export function Oferta() {
  return <section id="oferta" className="w-full bg-rosa-50 py-12 sm:py-20" aria-labelledby="oferta-titulo" data-id="element-122" data-mp="3nudo3f3prqig">
      <div className="mx-auto max-w-2xl px-5 sm:px-8" data-id="element-123" data-mp="3rue5n8m40htq">
        <Reveal data-id="element-124" data-mp="po137mz5a2w">
          <div className="overflow-hidden rounded-3xl border border-rosa-200 bg-white shadow-suave" data-id="element-125" data-mp="q78vviwui37">
            <div className="bg-frambuesa px-5 py-6 text-center sm:px-10" data-id="element-126" data-mp="174osd0121435">
              <p className="font-sans text-[11px] font-bold uppercase tracking-[0.2em] text-rosa-100 sm:text-xs" data-id="element-127" data-mp="1c3ruablqmu6w">
                Oferta especial por tiempo limitado
              </p>
              <h2 id="oferta-titulo" className="mt-2 font-serif text-2xl leading-tight text-white sm:text-4xl" data-id="element-128" data-mp="1isshrk68q4oo">
                Empezá hoy con Puntadas de Papel
              </h2>
            </div>

            <div className="px-5 py-7 sm:px-10 sm:py-10" data-id="element-129" data-mp="18ul9rqtxiwyt">
              <img src={IMAGENES.portada} alt="Portada del curso Puntadas de Papel" className="mx-auto mb-6 w-40 rounded-2xl border border-rosa-100 shadow-tarjeta sm:w-52" data-id="element-130" data-mp="18u34k4pah8er" />

              <ul className="space-y-2" data-id="element-131" data-mp="1019erdc7uqmn">
                {checklistOferta.map(item => <li key={item} className="flex items-start gap-3 rounded-2xl bg-crema px-4 py-3" data-id="element-132" data-mp="v2exiftwda4n">
                    <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-oliva" aria-hidden="true" data-id="element-133" data-mp="q4dbbm16cuoy" />
                    <span className="font-sans text-[15px] font-semibold leading-snug text-tinta sm:text-lg" data-id="element-134" data-mp="l50i8jjpmrdx">
                      {item}
                    </span>
                  </li>)}
              </ul>

              <div className="mt-8 text-center" data-id="element-135" data-mp="6h0eyhw0j6gf">
                <p className="font-sans text-base text-suave line-through decoration-terracota/60" data-id="element-136" data-mp="6kehbq4offnv">
                  Antes {PRECIO_ANTERIOR} {MONEDA}
                </p>
                <p className="mt-1 font-sans text-xs font-bold uppercase tracking-[0.2em] text-frambuesa" data-id="element-137" data-mp="3toc94nvqe0do">
                  Hoy pagás
                </p>
                <p className="mt-1 font-serif text-5xl text-borgona sm:text-6xl" data-id="element-138" data-mp="q5iyojy91rnq">
                  {PRECIO}
                  <span className="ml-2 align-middle font-sans text-lg font-bold text-suave" data-id="element-139" data-mp="u7w2h2tfrfhv">
                    {MONEDA}
                  </span>
                </p>
              </div>

              <div className="mt-7 flex flex-col items-center" data-id="element-140" data-mp="lessx5lwvmsi">
                <CTAButton href="https://deco-emprende.impultienda.ar/checkout/puntadas-de-papel" data-id="element-141" data-mp="ld7x7cnv1xt2">
                  Quiero acceder ahora
                </CTAButton>
                <p className="mt-3 text-center font-sans text-sm text-suave" data-id="element-142" data-mp="1dwewbxpdzh2w">
                  Pago único · Acceso inmediato · Producto digital
                </p>
              </div>

              
            </div>
          </div>
        </Reveal>
      </div>
    </section>;
}